import { render, staticRenderFns } from "./RankTableGoods.vue?vue&type=template&id=f7f1e5c8&scoped=true"
import script from "./RankTableGoods.vue?vue&type=script&lang=js"
export * from "./RankTableGoods.vue?vue&type=script&lang=js"
import style0 from "./RankTableGoods.vue?vue&type=style&index=0&id=f7f1e5c8&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f1e5c8",
  null
  
)

export default component.exports